import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';

const styles = (theme) => ({
  root: {
    paddingLeft: '5px',
    '& span': {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  itemText: {
    color: theme.palette.xpl.dm.text.secondary,
  },
  menuItemSelected: {
    color: theme.palette.xpl.foreground,
  },
  subMenuItemSelected: {
    color: theme.palette.xpl.dm.primary.default,
  },
});

const MenuItemText = (props) => {
  const { classes, name, selected, isSubMenuItem } = props;

  return (
    <ListItemText
      primary={name}
      className={classes.root}
      classes={
        !selected
          ? { primary: classes.itemText }
          : isSubMenuItem
          ? { primary: classes.subMenuItemSelected }
          : { primary: classes.menuItemSelected }
      }
    />
  );
};

MenuItemText.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  isSubMenuItem: PropTypes.bool,
};

MenuItemText.defaultProps = {
  selected: false,
  isSubMenuItem: false,
};

export default withStyles(styles)(MenuItemText);
